export const WEEK_NUMBER_FORMAT = {
  'ISO (first 4-day week)': [6, 7],
  American: [1, 2],
  'Hide week numbers': [0]
} as const

export type WeekNumberFormat =
  (typeof WEEK_NUMBER_FORMAT)[keyof typeof WEEK_NUMBER_FORMAT]
